var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageTail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 29,
    viewBox: "0 0 52 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000259399 29.0002V0.0771484L51.5664 16.5472H22.0997C6.06641 16.5472 -0.000259399 29.0002 -0.000259399 29.0002Z",
    fill: "#FFF4D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTail);
export default __webpack_public_path__ + "static/media/messageTail.28d0d2967242071865b13a70580c47cf.svg";
export { ForwardRef as ReactComponent };